import React from 'react'
import Navbar from '../../components/shared/Navbar/Navbar'
import Footer from '../../components/shared/Footer/Footer'
import AboutHero from '../../components/pages/About/AboutHero/AboutHero'
import Guided from '../../components/pages/About/Guided/Guided'

const About = () => {
  return (
    <div>
        <Navbar/>
        <AboutHero/>
        <Guided/>


        <Footer/>
    </div>
  )
}

export default About